module.exports = __webpack_public_path__ + "img/link-icon.1c913d74.svg";